import React from "react";
import "../../styles/mudur/SayfaYardimPopup.css";

function SayfaYardimPopup({
    open,
    onClose,
    title = "Sayfa Yardımı",
    sections = [],
}) {
    if (!open) return null;

    return (
        <div className="yardim-overlay" onClick={onClose}>
            <div
                className="yardim-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="yardim-modal-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="yardim-close-btn">
                        ×
                    </button>
                </div>

                <div className="yardim-modal-body">
                    {sections.map((section, index) => (
                        <div key={index} className="yardim-section">
                            <h4>{section.heading}</h4>

                            {section.text && <p>{section.text}</p>}

                            {section.items && section.items.length > 0 && (
                                <ul>
                                    {section.items.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

                <div className="yardim-modal-footer">
                    <button onClick={onClose} className="yardim-anladim-btn">
                        Anladım
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SayfaYardimPopup;